import { makePersisted } from '@solid-primitives/storage'
import { createRoot } from 'solid-js'
import { createStore } from 'solid-js/store'

export interface CompanyStateType {
  id: string | null
  name: string | null
  slug: string | null
  logo: string | null
  domain: string | null
}

const [companyStore, setCompanyStore] = createRoot(() =>
  makePersisted(
    createStore<CompanyStateType>({
      id: null,
      name: null,
      slug: null,
      logo: null,
      domain: null
    }),
    { name: 'fj-company', storage: localStorage }
  )
)

export { companyStore, setCompanyStore }
